/** Maps 0 to 'A', 1 to 'B', and so on — how choices are lettered throughout. */
export const alphabet = (index: number) => {
  return String.fromCharCode(65 + index);
};

/** How much of a question's text a tooltip shows before trailing off. */
const PREVIEW_LENGTH = 100;

/** The opening of a question's text, for tooltips that only stand in for the whole. */
export const preview = (text: string) => {
  return text.length > PREVIEW_LENGTH
    ? `${text.slice(0, PREVIEW_LENGTH)}…`
    : text;
};
